


import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../api";
import { UserName } from "../api";
import { Password } from "../api";


// setCookie -------------
export function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${cname}=${cvalue};${expires};path=/;SameSite=Lax`;
    // document.cookie = `${cname}=${cvalue};${expires};path=/;Secure`;
}

// deleteCookie -----------
export const deleteCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

// Toast alert ----
export const Toast = async (status, message) => {
    if (status === "error") {
        return toast.error(message, { autoClose: 2500 })
    } else {
        return toast.success(message, { autoClose: 2500 })
    }
}

// get the Cookie --------------------------
export const getCookie = (cname) => {
    var name = cname + "=";

    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export async function FetchGetRerquest(url) {
    let token = getCookie('kehTokan')


    try {
        const response = await fetch(`${BASE_URL}/${url}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}` // Set the Bearer token
            },
        });
        if (response) {
            return response;
        }

    } catch (err) {
        console.log(err);
        // Handle network or unexpected errors
        toast.error("An error occurred. Please try again later.");
        return { error: true, status: null, data: null };
    }
}

export async function FetchData(url, body) {

    let token = getCookie('kehTokan')
    // if (token) {
    try {
        const response = await axios.post(`${BASE_URL}/${url}`, body, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}` // Set the Bearer token
            },
        });

        if (response) {
            if (response.status === 200) {
                return response;
            }
        }

    } catch (err) {

        if (err.status === 401) {
            return err
        }
        else if (err.status === 400) {
            // Toast('error', 'Invalid Credentials');
            return err
        }
        else if (err.status === 404) {
            // Toast("error", 'Not Found');
            return err
        }
        else if (err.status === 403) {
            Toast("error", err?.response?.data?.apiStatus?.statusMessage);
            return
        }
        else if (err.status === 405) {
            Toast("error", 'Plase try Again');
            return
        }
        else if (err.status === 500) {
            Toast("error", 'Internal Server Error');
            return
        }

        else {
            Toast("error", err?.response?.statusText);
            return
        }
    }
}

export async function UploadImage(url, body) {

    let token = getCookie('kehTokan')
    // if (token) {
    try {
        const response = await axios.post(`${BASE_URL}/${url}`, body, {
            headers: {
                // "Content-Type": "application/json",
                "Authorization": `Bearer ${token}` // Set the Bearer token
            },
        });

        if (response) {
            if (response.status === 200) {
                return response;
            }
        }

    } catch (err) {

        if (err.status === 401) {
            return err
        }
        else if (err.status === 400) {
            // Toast('error', 'Invalid Credentials');
            return err
        }
        else if (err.status === 404) {
            Toast("error", 'Not Found');
            return
        }
        else if (err.status === 403) {
            Toast("error", err?.response?.data?.apiStatus?.statusMessage);
            return
        }
        else if (err.status === 405) {
            Toast("error", 'Plase try Again');
            return
        }
        else if (err.status === 500) {
            Toast("error", 'Check Your Internet');
            return
        }

        else {
            Toast("error", err?.response?.statusText);
            return
        }
    }
}

export async function FetchUserApi(PATH, User) {

    const encodedCredentials = btoa(`${UserName}:${Password}`);

    try {
        const response = await axios.post(`${BASE_URL}/${PATH}`, User, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Basic ${encodedCredentials}` // Set Basic Auth header
            }
        });

        if (response.status == 200) {
            return response
        } else{
            console.log(response);
            Toast("error", response.data?.apiStatus?.statusMessage || "Unknown error");
            return response
        }

    } catch (err) {
        
        if (err.status === 400) {
            console.log(err.status);
            Toast("error", err.response.data?.apiStatus?.statusMessage);
            Toast("error", err.response.data);
            return err
        } else if (err.status === 404) {
            Toast("error", err.response.data.apiStatus.statusMessage);
        }
        else if (err.status === 405) {
            Toast("error", 'Please try again later.'); //methos not allow
        }
         else if (err.status === 401) {
            Toast("error", 'Authorization denied');
        } else {
            Toast("error", "Please try again later.");
        }
    }
}


export const shortTextLength = (item, keyLength) => {
    let shortItem;
    if (item.length > keyLength) {
        shortItem = item && item?.length > 10 ? item.slice(0, keyLength) + '...' : item
    } else {
        shortItem = item
    }

    return shortItem
}

export function ShortestLength(id, content) {

    const intervalId = setTimeout(() => {
        let element = document.getElementById(`${Number(id) + 1}Notes`);

        if (element) {
            element.innerHTML = content;
        } else {
            console.warn(`Element with ID '${Number(id) + 1}Notes' not found`);
        }
    }, 50); 
}

// Convert ArrayBuffer to Base64
function arrayBufferToBase64(buffer) {
    const uint8Array = new Uint8Array(buffer);
    let binary = '';
    uint8Array.forEach((byte) => {
      binary += String.fromCharCode(byte);
    });
    return window.btoa(binary);
  }
  
  // Convert Base64 to ArrayBuffer
  function base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const byteArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i);
    }
    return byteArray.buffer;
  }
  
  // Generate AES key
 export async function generateKey() {
    return await crypto.subtle.generateKey(
      {
        name: "AES-GCM",
        length: 256, // Key length
      },
      true,
      ["encrypt", "decrypt"]
    );
  }
  
  // Encrypt URL and return Base64 encoded result
  async function encryptUrlToBase64(url, key) {
    const encoder = new TextEncoder();
    const encodedUrl = encoder.encode(url);
  
    // Generate a random IV (Initialization Vector)
    const iv = crypto.getRandomValues(new Uint8Array(12));
  
    // Encrypt the URL
    const encryptedUrl = await crypto.subtle.encrypt(
      {
        name: "AES-GCM",
        iv: iv,
      },
      key,
      encodedUrl
    );
  
    // Convert encrypted data to Base64 and return along with the IV
    return {
      encryptedUrlBase64: arrayBufferToBase64(encryptedUrl),
      ivBase64: arrayBufferToBase64(iv),
    };
  }
  
  // Decrypt Base64 encrypted URL
  async function decryptUrlFromBase64(encryptedUrlBase64, ivBase64, key) {
    // Convert Base64 to ArrayBuffer
    const encryptedUrl = base64ToArrayBuffer(encryptedUrlBase64);
    const iv = base64ToArrayBuffer(ivBase64);
  
    // Decrypt the URL
    const decryptedData = await crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: iv,
      },
      key,
      encryptedUrl
    );
  
    // Decode the decrypted data back to string
    const decoder = new TextDecoder();
    const decryptedUrl = decoder.decode(decryptedData);
    return decryptedUrl;
  }
  
  // Example usage
//   (async () => {
//     const key = await generateKey();
//     const url = "";
    
//     // Encrypt the URL and get Base64 result
//     const { encryptedUrlBase64, ivBase64 } = await encryptUrlToBase64(url, key);
//     console.log("Encrypted URL in Base64:", encryptedUrlBase64);
//     console.log("IV in Base64:", ivBase64);
  
//     // Decrypt the URL from Base64
//     const decryptedUrl = await decryptUrlFromBase64(encryptedUrlBase64, ivBase64, key);
//     console.log("Decrypted URL:", decryptedUrl);
//   })();
  